<template>
    <div class="user-questionnaire-form-container w-100 user-modal-register-view px-2" :style="containerStyle">
        <template>
            <div class="w-100 mb-4">
                <div class="mb-2 text-center">
                    <p class="font-weight-bold font-size-200 mb-0">{{ 'Tell us about yourself' | trans }}</p>
                </div>
                <div class="mb-2 text-center py-2">
                    {{ "And we'll personalize your experience for %project%!" | trans({ '%project%': projectName }) }}
                </div>

                <DotNavigation></DotNavigation>

                <div class="text-center py-2 mb-2">
                    <strong>{{ 'Tell us more about your work environment' | trans }}</strong>
                </div>

                <div v-if="isStatusDone">
                    <div class="mb-3">
                        <select
                            name="industry"
                            id="industry"
                            class="w-100 p-2 br-4 border bg-white"
                            v-model="industryValue"
                            :disabled="isSubmitting"
                        >
                            <option value="" disabled>{{ 'Industry' | trans }}</option>
                            <option value="Construction and architecture">
                                {{ 'Construction and architecture' | trans }}
                            </option>
                            <option value="Education">{{ 'Education' | trans }}</option>
                            <option value="Financial services">{{ 'Financial services' | trans }}</option>
                            <option value="Government and non-profit">{{ 'Government and non-profit' | trans }}</option>
                            <option value="Healthcare">{{ 'Healthcare' | trans }}</option>
                            <option value="Information technology">{{ 'Information technology' | trans }}</option>
                            <option value="Law and Legal">{{ 'Law and Legal' | trans }}</option>
                            <option value="Management consulting">{{ 'Management consulting' | trans }}</option>
                            <option value="Marketing, communication and design">
                                {{ 'Marketing, communication and design' | trans }}
                            </option>
                            <option value="Real estate">{{ 'Real estate' | trans }}</option>
                            <option value="Sports">{{ 'Sports' | trans }}</option>
                            <option value="Wholesale, logistics, and retail">
                                {{ 'Wholesale, logistics, and retail' | trans }}
                            </option>
                            <option value="other">{{ 'Other (Freeform)' | trans }}</option>
                        </select>
                    </div>

                    <div v-if="industryValue === 'other'" class="mx-auto p-0 mb-4">
                        <TextArea
                            name="form"
                            type="text"
                            v-model="industryFreefieldValue"
                            :label="getPlaceholder"
                            :max-characters="180"
                            :disabled="isSubmitting"
                        ></TextArea>
                    </div>

                    <div class="mb-3">
                        <select
                            name="department"
                            id="department"
                            class="w-100 p-2 br-4 border bg-white"
                            v-model="departmentValue"
                            :disabled="isSubmitting"
                        >
                            <option value="" disabled>{{ 'Department' | trans }}</option>
                            <option value="Administration">{{ 'Administration' | trans }}</option>
                            <option value="Design">{{ 'Design' | trans }}</option>
                            <option value="Finance">{{ 'Finance' | trans }}</option>
                            <option value="Legal">{{ 'Legal' | trans }}</option>
                            <option value="Marketing">{{ 'Marketing' | trans }}</option>
                            <option value="Operations">{{ 'Operations' | trans }}</option>
                            <option value="Sales">{{ 'Sales' | trans }}</option>
                            <option value="Teacher/Coach">{{ 'Teacher/Coach' | trans }}</option>
                            <option value="other">{{ 'Other (Free form)' | trans }}</option>
                        </select>
                    </div>

                    <div v-if="departmentValue === 'other'" class="mx-auto p-0 mb-4">
                        <TextArea
                            name="form"
                            type="text"
                            v-model="departmentFreefieldValue"
                            :label="getPlaceholder"
                            :max-characters="180"
                            :disabled="isSubmitting"
                        ></TextArea>
                    </div>

                    <div class="mb-5">
                        <select
                            name="company_size"
                            id="company_size"
                            class="w-100 p-2 br-4 border bg-white"
                            v-model="companySizeValue"
                            :disabled="isSubmitting"
                        >
                            <option value="" disabled>{{ 'Company size' | trans }}</option>
                            <option value="Just me">{{ 'Just me' | trans }}</option>
                            <option value="2-20 employees">{{ '2-20 employees' | trans }}</option>
                            <option value="20-100 employees">{{ '20-100 employees' | trans }}</option>
                            <option value="20-500 employees">{{ '20-500 employees' | trans }}</option>
                            <option value="500+ employees">{{ '500+ employees' | trans }}</option>
                        </select>
                    </div>
                </div>

                <LoadingAnimation v-else-if="isStatusLoading" animation-style="bars" classes="mb-4"></LoadingAnimation>

                <div>
                    <ButtonWithLoadingState
                        data-user-modal-button-submit
                        class="btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4"
                        :text="'Done' | trans"
                        :is-state-loading="isSubmitting"
                        @click.stop.prevent="saveProfile"
                    ></ButtonWithLoadingState>
                </div>
                <div class="text-center">
                    <button @click.stop.prevent="onBackButtonClick" :disabled="isSubmitting" class="btn btn-lg">
                        {{ 'Back' | trans }}
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation';
import DataStatus from '../../../../../qaamgo/modules/sat/components/mixins/DataStatus';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../../../qaamgo/helper/translate';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { userQuestionnaireModalHelper } from '../user-questionnaire-modal-helper';
import { pageNotification } from '../../../../../qaamgo/helper/notify';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';

import { pageStoreMixin } from '../../../../store/page-store';
import { userQuestionnaireModalRoute } from '../../user_questionnaire/router';
import TextArea from '../../../../../qaamgo/modules/sat/components/form/TextArea';
import DotNavigation from '../components/DotNavigationComponent';

export default {
    name: 'WorkEnvironmentForm',
    components: { DotNavigation, LoadingAnimation, TextArea, ButtonWithLoadingState },
    mixins: [DataStatus, TransFilter, pageStoreMixin],
    mounted() {
        this.setStatusDone();
    },
    methods: {
        async saveProfile() {
            let profiles = [];

            if (this.industryValue !== '') {
                let currentIndustryValue = this.industryValue;

                if (this.industryValue === 'other') {
                    currentIndustryValue = this.industryFreefieldValue;
                }

                profiles.push({ industry: currentIndustryValue });
            }

            if (this.departmentValue !== '') {
                let currentDepartmentValue = this.departmentValue;

                if (this.departmentValue === 'other') {
                    currentDepartmentValue = this.departmentFreefieldValue;
                }

                profiles.push({ department: currentDepartmentValue });
            }

            if (this.companySizeValue !== '') {
                profiles.push({ company_size: this.companySizeValue });
            }

            await userQuestionnaireModalHelper.saveProfile(profiles);

            this.store.questionnaireModal.close();
        },
        onBackButtonClick() {
            try {
                this.$router.back();
            } catch (e) {
                globalLogger.log('WorkEnvironmentForm - back button fail', e);

                pageNotification.showGenericErrorMessage();
            }
        },
    },
    computed: {
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.questionnaireModal.getSubmitting;
        },
        getPlaceholder() {
            return translate('Please specify');
        },
    },
    props: {
        containerStyle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            userQuestionnaireModalRoute: userQuestionnaireModalRoute,
            csrfToken: '',
            projectName: satGlobals.getProjectName(),
            openFreeForm: false,
            industryValue: '',
            industryFreefieldValue: '',
            departmentValue: '',
            departmentFreefieldValue: '',
            companySizeValue: '',
        };
    },
};
</script>
